import {routes} from '@constants/routes';
import {renderModalError} from '@utils/forms';

export const udpOriginEntryPointsModalError = () => {
    return renderModalError('UDP Origin Entry Point', routes.udpOriginEntryPoint.index.path);
};
